import { lazy } from "react";
export var LazyEncapsulatedQuickAdd = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: "encapsulated-quick-add" */ "./EncapsulatedQuickAdd").then(function(m) {
        return {
            default: m.EncapsulatedQuickAdd
        };
    });
});
